import React from "react";

const IntlTransfersOptions = (props) => {
  const options = [
    {
      text: 'Vers quels pays puis-je envoyer de l’argent?',
      handler: props.actionProvider.handleIntlTransfersOptions1,
      id: 1,
    },
    {
    text: 'Comment dois-je procéder pour faire un virement international par Mastercard et INTERAC?',
      handler: props.actionProvider.handleIntlTransfersOptions2,
      id: 2
    },
    {
      text: 'Qu’est-ce qu’un numéro IBAN?',
      handler: props.actionProvider.handleIntlTransfersOptions3,
      id: 3
    },
    {
      text: 'Y a-t-il des frais et des limites assortis aux virements internationaux par Mastercard et INTERAC?',
      handler: props.actionProvider.handleIntlTransfersOptions4,
      id: 4
    },
    {
      text: 'Quel sera le taux de change appliqué?',
      handler: props.actionProvider.handleIntlTransfersOptions5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container intltransfer-products'>{optionsMarkup}</div>;
};

export default IntlTransfersOptions;